import { PlayAction, PlayActionTypes } from 'app/dux/play/types';
import { Reducer } from 'redux';
import { PlayState } from './interfaces';

const initialState: PlayState = {
    playingRomId: null
};

export const playReducer: Reducer<PlayState, PlayAction> = (state = initialState, action: PlayAction) => {
    switch (action.type) {
        case PlayActionTypes.PLAY_ROM_FILE:
            return {
                ...state,
                playingRomId: action.romId,
            };
        case PlayActionTypes.STOP_PLAYING:
            return {
                ...state,
                playingRomId: null,
            };
        default:
            return state;
    }
};
